import vClickOutside from 'v-click-outside';

export default {
  data() {
    return {
      showDropDown: false
    };
  },

  directives: {
    clickOutside: vClickOutside.directive
  }
};
